import { CUSTOM_ELEMENTS_SCHEMA, NgModule, isDevMode } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { HTTP_INTERCEPTORS } from '@angular/common/http';
import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { ErrorPageComponent } from './components/error-page/error-page.component';
import { aos, AosToken } from './animation/aos';
import { HttpConfigInterceptor } from './Interceptors/http-config.interceptor';
import { SharedModule } from './lazy-load-modules/shared-module/shared.module';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { CommonService } from './services/Common-function/common.service';
import { MessageService } from 'primeng/api';
import { DatePipe, NgOptimizedImage } from '@angular/common';
import { AuthService } from './services/Auth/auth.service';
import { BeatsService } from './services/beats-service/beats.service';
import { PlayerService } from './services/music-player/player.service';
import { SocketIoService } from './services/socket/socket-io.service';
import { ComingSoonComponent } from './components/coming-soon/coming-soon.component';
import { Ga4trackingService } from './services/ga4Tracking/ga4tracking.service';
import { CookiesService } from './services/cookies/cookies.service';
import { SupportRedirectComponent } from './components/support-redirect/support-redirect.component';

const  components = [
  ErrorPageComponent,
  AppComponent,
  ComingSoonComponent,
  SupportRedirectComponent
]

@NgModule({
  declarations: [
    ...components
  ],
  imports: [
    BrowserModule,
    BrowserAnimationsModule,
    AppRoutingModule,
    SharedModule,
    NgOptimizedImage
  ],
  providers: [
    { provide: AosToken, useValue: aos },
    { provide: HTTP_INTERCEPTORS, useClass: HttpConfigInterceptor, multi: true },
    BeatsService,
    PlayerService,
    CommonService,
    MessageService,
    DatePipe,
    AuthService,
    SocketIoService,
    Ga4trackingService,
    CookiesService
  ],
  exports: [
    SharedModule
  ],
  schemas: [ CUSTOM_ELEMENTS_SCHEMA],
  bootstrap: [AppComponent]
})
export class AppModule { }
